export enum ModalActionStatus {
    Iddle = 'IDDLE',
    Pending = 'PENDING',
    Finished = 'FINISHED',
    Error = 'ERROR'
}
